import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { AuthGuard } from "../App";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGift, faCalendarAlt, faTicketAlt, faPaperPlane, faSpinner } from "@fortawesome/free-solid-svg-icons"; // Added icons

const PromoCodePage = () => {
  const [promoCode, setPromoCode] = useState("");
  const [loading, setLoading] = useState(false); // Add loading state
  const navigate = useNavigate();

  const handleSubmit = async () => {
    setLoading(true); // Set loading to true on submission start
    try {
      const token = localStorage.getItem("token");
      const userDataString = localStorage.getItem("user");
      let userId = null;

      if (userDataString) {
        try {
          const userData = JSON.parse(userDataString);
          userId = userData.unique;
        } catch (parseError) {
          console.error("Error parsing user data:", parseError);
          toast.error("User data corrupted. Please log in again.");
          setLoading(false);
          return;
        }
      }

      if (!token || !userId) {
        toast.warn("Authentication details missing. Please log in to apply a promo code.");
        setLoading(false);
        return;
      }

      const response = await axios.post(
        `https://backend.inyumba.co.ke/iNyumba/promocoderetrieval/${userId}`,
        { code: promoCode },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success === true) {
        setPromoCode(""); // Empty the input field
        toast.success(response.data.response || "Promo code applied successfully!");
      } else {
        toast.error(response.data.response || "Failed to apply promo code. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting promo code:", error);
      if (error.response && error.response.data && error.response.data.response) {
        toast.error(error.response.data.response);
      } else {
        toast.error("An unexpected error occurred. Please try again.");
      }
    } finally {
      setLoading(false); // Set loading to false on submission end
    }
  };

  return (
    <AuthGuard>
      <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-green-50 to-teal-100 p-4 sm:p-6 lg:p-8">
        
        <div className="bg-white rounded-3xl shadow-2xl p-8 sm:p-10 lg:p-12 max-w-lg w-full text-center animate-fade-in-down">
          <div className="flex items-center justify-center mb-6">
            <FontAwesomeIcon icon={faGift} className="text-teal-600 text-6xl mr-4" />
            <h1 className="text-5xl font-extrabold text-gray-900">
              Unlock Your Savings!
            </h1>
          </div>
          <p className="text-gray-600 text-lg mb-8">
            Enter your exclusive promo code below to apply discounts or special offers to your account.
          </p>
          <span className="text-gray-700 text-xl font-semibold flex items-center justify-center mb-10">
            <FontAwesomeIcon icon={faCalendarAlt} className="mr-3 text-2xl" />
            Today's Date: {new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
          </span>

          <div className="flex flex-col items-center space-y-6">
            <div className="relative w-full max-w-sm">
              <input
                type="text"
                value={promoCode}
                onChange={(e) => setPromoCode(e.target.value)}
                className="border-2 border-green-300 p-4 pl-12 rounded-xl w-full text-lg text-gray-800 placeholder-gray-400 shadow-md
                           focus:ring-4 focus:ring-green-200 focus:border-green-500 transition-all duration-300"
                placeholder="Enter your promo code here (e.g., SAVEBIG)"
                aria-label="Promo Code Input"
              />
              <FontAwesomeIcon icon={faTicketAlt} className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-xl" />
            </div>
            <button
              onClick={handleSubmit}
              className={`flex items-center justify-center space-x-3
                        bg-gradient-to-r from-teal-500 to-green-600 text-white
                        px-8 py-4 rounded-xl text-xl font-bold shadow-lg
                        transition-all duration-300 transform hover:scale-105 hover:shadow-xl
                        focus:outline-none focus:ring-4 focus:ring-teal-300 focus:ring-offset-2
                        ${loading ? "opacity-70 cursor-not-allowed" : ""}`}
              disabled={loading} // Disable button when loading
            >
              {loading ? (
                <FontAwesomeIcon icon={faSpinner} spin className="text-white text-2xl" />
              ) : (
                <FontAwesomeIcon icon={faPaperPlane} />
              )}
              <span>{loading ? "Applying..." : "Apply Code"}</span>
            </button>
          </div>
        </div>
      </div>
    </AuthGuard>
  );
};

export default PromoCodePage;